export * from './ProductDetailBanners';
